<template>
    <div>
        <div class="d-flex flex-column min-vh-100">
            <div class="flex-grow-1 d-flex flex-column">
                <div class="header d-flex justify-content-center">
                    <a :href="$t('order.ai_proofreader.upload_document.logo.link')" class="d-flex text-decoration-none">
                        <img src="~/assets/img/logo.svg" alt="">
                        <h3 class="mb-0 ml-2" v-text="title" />
                    </a>
                </div>
                <nuxt />
            </div>

            <HappinessGuarantee v-if="showHappinessGuarantee" />
            <Footer :footer-links="footerLinks" />
        </div>
        <PortalTarget name="modal" />
    </div>
</template>

<script>
import Base from './base';
import Footer from 'frontend-resources/components/Footer/Footer';
import HappinessGuarantee from '@/components/HappinessGuarantee';

export default {
    components: { Footer, HappinessGuarantee },
    extends: Base,
    computed: {
        title: function () {
            return this.$i18n.t('order.ai_proofreader.upload_document.logo.title');
        },
    },
};
</script>

<style lang="scss" scoped>
.header {
  margin-top: 2.5rem;

  a {
    width: fit-content;
  }
}

</style>
